import React from "react";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { IconButton, List, Toolbar } from "@mui/material";
import { useNavigationGuard } from "@context/NavigationGuardContext";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { startScreenNavigation } from "@telemetry/navigationTiming";
import { AppNavigationItems } from "@utils/navigation";
import { useNavigate } from "react-router-dom";
import NavigationMenuItem from "./NavigationMenuItem";

interface NavigationMenuProps {
  openSidebar: (callback: (prev: boolean) => boolean) => void;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ openSidebar }) => {
  const navigate = useNavigate();
  const { requestNavigation } = useNavigationGuard();
  const { userAccessPermissions, customSecurityClearancePath } = useAuthStore();

  const navItems = AppNavigationItems(
    userAccessPermissions,
    window.location.pathname,
    customSecurityClearancePath,
  );

  const handleClick = (path: string, label: string) => {
    startScreenNavigation("Main Navigation", window.location.pathname, label);
    requestNavigation(() => navigate(path));
  };
  return (
    <Toolbar
      disableGutters
      sx={{
        minHeight: "0 !important",
        padding: "0 12px 12px",
      }}
    >
      <List component="nav" className="flex" disablePadding>
        <IconButton
          size="medium"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={() => openSidebar((prev: boolean) => !prev)}
        >
          <MenuOutlinedIcon />
        </IconButton>
        {navItems.map(({ testId, title, submenu, path, isVisible, isActive }) => (
          <NavigationMenuItem
            key={testId}
            testId={testId}
            label={title}
            isActive={isActive}
            submenu={submenu}
            isVisible={isVisible}
            onClick={() => handleClick(path, title)}
            menuId={`${testId}-menu`}
          />
        ))}
      </List>
    </Toolbar>
  );
};

export default NavigationMenu;
